// import React from "react";
// import { Row, Col, Card, Typography } from "antd";
// import {
//   DollarOutlined,
//   AppstoreOutlined,
//   RiseOutlined,
//   TeamOutlined
// } from "@ant-design/icons";

// //import "./DashboardCards.scss";
// import './ApplicantDashboardNewStyle.css';
// const { Text } = Typography;

// const iconMap = {
//   dollar: <DollarOutlined />,
//   briefcase: <AppstoreOutlined />,
//   trend: <RiseOutlined />,
//   users: <TeamOutlined />
// };

// const DashboardCards = () => {
//     const dashboardData = [
//   {
//     key: "portfolio",
//     title: "Credit Limit", 
//     value: "$847M",
//     description: "+12.3% from last quarter",
//     icon: "dollar",
//     highlight: true
//   },
//   {
//     key: "investments",
//     title: "Outstanding Balance",
//     value: "24",
//     description: "Across 6 asset classes",
//     icon: "briefcase"
//   },
//   {
//     key: "irr",
//     title: "Available to Draw",
//     value: "+15.7%",
//     description: "+2.1% vs benchmark",
//     icon: "trend"
//   },
//   {
//     key: "managers",
//     title: "In-Process Amount",
//     value: "18",
//     description: "Top-tier partnerships",
//     icon: "users"
//   }
// ];


//   return (
//     <Row gutter={[16, 16]}>
//       {dashboardData.map((item) => (
//         <Col
//           key={item.key}
//           xs={24}
//           sm={12}
//           lg={6}
//           className="dashbaordInfoCardColumn"
//         >
//           <Card className="dashboard-card">
//             <div className="card-header">
//               <Text className="card-title">{item.title}</Text>
//               <span className="card-icon">{iconMap[item.icon]}</span>
//             </div>

//             <div className="card-value">{item.value}</div>

//             <Text className="card-description">
//               {item.description}
//             </Text>
//           </Card>
//         </Col>
//       ))}
//     </Row>
//   );
// };

// export default DashboardCards;


import React, { useEffect, useState } from "react";
import { Row, Col, Card, Typography, Form } from "antd";
import _NewapplicationService from "../../modules/NewapplicationService";
import "./ApplicantDashboardNewStyle.css";
import { UserOutlined, DollarOutlined, UpCircleFilled, DownCircleFilled, ClockCircleOutlined, CreditCardOutlined, DollarCircleOutlined, WalletOutlined, FileTextOutlined, ArrowRightOutlined,SyncOutlined } from "@ant-design/icons";


const { Text } = Typography;

const DashboardCards = () => {
  const [summary, setSummary] = useState({});
  const [loading, setLoading] = useState(false);

  const email = localStorage.getItem("loginEmail");

  const bankadminIdRaw = localStorage.getItem("BankerId");
  const bankerID = bankadminIdRaw ? parseInt(bankadminIdRaw) : null;

  const [bankerId, setBankerId] = useState(bankerID);
  const [form] = Form.useForm();

  // Set form value when bankerId changes
  useEffect(() => {
    if (bankerId) {
      form.setFieldsValue({ role: bankerId });
    }
  }, [bankerId, form]);

  // Listen for bankerId changes
  useEffect(() => {
    const handleBankrIdChange = (e) => {
      const newId = e.detail.newId;
      setBankerId(newId);
    };

    window.addEventListener("BankerIdChanged", handleBankrIdChange);

    return () => {
      window.removeEventListener("BankerIdChanged", handleBankrIdChange);
    };
  }, []);

  // Load dashboard data
  useEffect(() => {
    if (email && bankerId) {
      GetApplicantDashboardDataByEmailAndBanker();
    }
  }, [email, bankerId]);

  const GetApplicantDashboardDataByEmailAndBanker = async () => {
    setLoading(true);

    try {
      const res = await _NewapplicationService.getApplicantDashboardDataByEmailAndBanker(email, bankerId);

      if (res?.data) {
        setSummary(res.data.Summary || {});
      }
    } catch (e) {
      console.log("Dashboard API Error:", e);
    } finally {
      setLoading(false);
    }
  };

  const iconMap = {
    dollar: <CreditCardOutlined />,
    briefcase: <DollarCircleOutlined />,
    trend: <WalletOutlined />,
    users: <SyncOutlined />,
  };

  const formatCurrency = (amount) => {
    return `$${Number(amount || 0).toLocaleString("en-US", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })}`;
  };

  // ✅ Updated structure
  const dashboardData = [
    {
      key: "credit",
      title: "Credit Limit",
      value: formatCurrency(summary?.CreditLimit),
      icon: "dollar",
    },
    {
      key: "outstanding",
      title: "Outstanding Balance",
      value: formatCurrency(summary?.OutstandingBalance || 0),
      icon: "briefcase",
    },
    {
      key: "available",
      title: "Available to Draw",
      value: formatCurrency(summary?.AvailabletoDraw || 0),
      icon: "trend",
    },
    {
      key: "process",
      title: "In-Process Amount",
      values: [
        {
          label: "Total Distribution",
          value: formatCurrency(summary?.TotalDistributionAmount || 0),
        },
        {
          label: "Total Loan Draw",
          value: formatCurrency(summary?.TotalLoanDrawAmount || 0),
        },
      ],
      icon: "users",
    },
  ];

  return (
    <Row gutter={[16, 16]}>
      {dashboardData.map((item) => (
        <Col
          key={item.key}
          xs={24}
          sm={12}
          lg={6}
          className="dashbaordInfoCardColumn"
        >
          <Card className="dashboard-card" loading={loading}>
            <div className="card-header">
              <Text className="card-title">{item.title}</Text>
              <span className="card-icon">{iconMap[item.icon]}</span>
            </div>

            <div className="card-value">
              {item.values ? (
                item.values.map((val, index) => (
                  // <div key={index}>
                  //   {val.label} : {val.value}
                  // </div>
                  <div key={index}>
                    <Text className="card-title">{val.label} :</Text>
                    <span> {val.value}</span>
                  </div>
                ))
              ) : (
                item.value
              )}
            </div>
          </Card>
        </Col>
      ))}
    </Row>
  );
};

export default DashboardCards;